import React from "react";
import Test from "../testi/Test";

const Home2 = () => {
  return (
    <div id="homepage">
      <div>
        <div className="">
          <div
            className=" homeSection "
            style={{
              minHeight: "90vh",
              minWidth: "100vw",
              marginTop: "-55px",
            }}
          >
            {/* <h1 className="border">df</h1> */}

            <div className="d-flex justify-content-center">
              <Test></Test>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home2;
